import * as Yup from 'yup';
import { FieldData, Select } from 'vopay';
import { useTranslation } from 'react-i18next';

export type BillingFormValues = {
  package: string;
};

type PackageOption = { id: string; label: string };

const useBillingFields = (
  packageOptions: PackageOption[],
  onPackageChange: (packageId: string) => void,
  isPackagesLoading: boolean,
  isDisabled = false,
): FieldData<BillingFormValues>[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'R1AccountCreation.Billing' });

  return [
    {
      fieldName: 'package',
      label: () => t('Package.label', { defaultValue: 'Package' }),
      getInputState: () => 'required',
      showField: () => true,
      validate: () => Yup.string().required(),
      renderField: ({ getFormikData }) => {
        const fieldData = getFormikData<string>({
          onChange: (event) => {
            if (event.target.value) {
              onPackageChange(event.target.value);
            }
          },
        });
        return (
          <Select
            version="2"
            options={packageOptions}
            optionValue={(o) => o.id}
            optionLabel={(o) => o.label}
            loading={isPackagesLoading}
            placeholder={t('Package.placeholder', { defaultValue: 'Select a Billing Package' })}
            {...fieldData}
            disabled={isDisabled || fieldData.disabled}
          />
        );
      },
    },
  ];
};

export default useBillingFields;
